export default "__VITE_PUBLIC_ASSET__b3fb377d__"